import get from 'lodash/get';
import { takeEvery, put } from 'redux-saga/effects';
import { consts as postsList } from './postsList';
import { consts as postDetails } from './postDetails';
import { consts as commentsList } from './commentsList';

function* postDetailsWorker() {
  yield put({
    type: postDetails.CLEAR,
  });
}

export function* postDetailsSaga() {
  yield takeEvery(postsList.RESTORE, postDetailsWorker);
}

function* postCommentsWorker(action) {
  yield put({
    type: postDetails.ADD_COMMENTS,
    payload: get(action, 'payload.newComments.length', 0),
  });
  yield put({
    type: postsList.POST_COMMENTS_CHANGED,
    payload: {
      postId: get(action, 'payload.postId'),
      change: get(action, 'payload.newComments.length', 0),
    },
  });
}

export function* postCommentsSaga() {
  yield takeEvery(commentsList.UPDATE_COMMENTS_LIST, postCommentsWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/postDetailsSaga.js